/* Ted&Co — v2 page kit: reveal-on-scroll + active topic chip. */
(function () {
  var items = document.querySelectorAll('.tv2 [data-tv2-reveal]');
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
  } else if (items.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  var nav = document.querySelector('.tv2 [data-tv2-index]');
  if (!nav || !('IntersectionObserver' in window)) return;
  var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
  var map = {};
  links.forEach(function (a) {
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (target) map[target.id] = a;
  });
  var spy = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (a) { a.classList.remove('is-active'); });
        var link = map[entry.target.id];
        if (link) {
          link.classList.add('is-active');
          if (link.scrollIntoView && window.matchMedia('(max-width: 767px)').matches) {
            var list = link.parentElement;
            list.scrollTo({ left: link.offsetLeft - 20, behavior: 'smooth' });
          }
        }
      });
    },
    { rootMargin: '-35% 0px -60% 0px' }
  );
  Object.keys(map).forEach(function (id) { spy.observe(document.getElementById(id)); });
})();
